exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-filemanager-window{width:460px;height:450px}#asseco-filemanager-window .asseco-list-item-label{width:calc(100% - 40px);display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.asseco-files-confirmed,.asseco-files-waiting{color:#fff;background-color:#b71c1c;padding:2px;font-size:11px}.asseco-files-confirmed{background-color:#1b5e20}@media only screen and (max-width:550px),screen and (max-height:510px){#asseco-filemanager-window{width:100%!important;height:100%!important;position:fixed!important;top:0;left:0}}", ""]);

// exports
